import { Receipt } from './types';

export const firestoreReceiptToBookingReceipt = (rec: any): Receipt => {
  rec.createdAt = rec.createdAt.toDate();
  return rec;
};
